/**
 * 各瀏覽器／打包器在「動態載入的 JS／CSS 檔案取不到」時的錯誤訊息。
 * 刻意不收單純的 "Failed to fetch"：那是一般 API 呼叫失敗，不代表前端檔案過期。
 */
const CHUNK_LOAD_MESSAGE_PATTERN = new RegExp(
    [
        'failed to fetch dynamically imported module', // Chromium
        'error loading dynamically imported module', // Firefox
        'importing a module script failed', // Safari
        'failed to load module script', // MIME type 不符（伺服器回 index.html）
        'expected a javascript-or-wasm module script',
        'unable to preload css', // Vite 的 CSS 預載
        'loading (css )?chunk \\S+ failed', // webpack 風格
        'chunkloaderror',
    ].join('|'),
    'i'
);

const CHUNK_LOAD_ERROR_NAME = 'ChunkLoadError';

function readMessage(error: unknown): string {
    if (typeof error === 'string') return error;
    if (error instanceof Error) return error.message;
    if (typeof error === 'object' && error !== null && 'message' in error) {
        return String((error as { message: unknown }).message);
    }
    return '';
}

/** 動態 import 得到 undefined（見 chunkErrorListeners 的說明）時，補成明確的 chunk 載入錯誤 */
export class ChunkLoadError extends Error {
    constructor(message: string) {
        super(message);
        this.name = CHUNK_LOAD_ERROR_NAME;
    }
}

export function isChunkLoadError(error: unknown): boolean {
    if (error instanceof Error && error.name === CHUNK_LOAD_ERROR_NAME) return true;
    return CHUNK_LOAD_MESSAGE_PATTERN.test(readMessage(error));
}
